// Animations
document.addEventListener('DOMContentLoaded', () => {
    const elements = document.querySelectorAll('[data-animate]');

    if (!elements.length) {
        return;
    }

    if (!('IntersectionObserver' in window)) {
        elements.forEach(el => {
            el.classList.add('animate-' + el.dataset.animate, 'visible');
        });

        return;
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0
    });

    elements.forEach(el => {
        const animationClass = 'animate-' + el.dataset.animate;
        el.classList.add(animationClass);
        observer.observe(el);
    });
});

function toggleOnScroll(target, options = {}) {
    const {
        offset = 20,
        display = "block",
        onShow = null,
        onHide = null
    } = options;

    const element =
        typeof target === "string"
            ? document.querySelector(target)
            : target;

    if (!element) return;

    let lastVisibleState = null;
    let isTicking = false;

    if (display === "flex") {
        element.style.justifyContent = "center";
        element.style.alignItems = "center";
    }

    function handleScroll() {
        const scrollTop =
            document.body.scrollTop ||
            document.documentElement.scrollTop;
        const isVisible = scrollTop > offset;

        if (isVisible === lastVisibleState) {
            return;
        }

        lastVisibleState = isVisible;

        if (isVisible) {
            element.style.display = display;

            if (typeof onShow === "function") {
                onShow(element);
            }
        } else {
            element.style.display = "none";

            if (typeof onHide === "function") {
                onHide(element);
            }
        }
    }

    const requestScrollUpdate = () => {
        if (isTicking) {
            return;
        }

        isTicking = true;

        window.requestAnimationFrame(() => {
            handleScroll();
            isTicking = false;
        });
    };

    window.addEventListener("scroll", requestScrollUpdate, { passive: true });
    handleScroll();
}

// Floating controls
document.addEventListener("DOMContentLoaded", function () {
    toggleOnScroll("#to-top", {
        offset: 50,
        display: "flex"
    });

    const scrollToTopBtn = document.getElementById("to-top");

    if (scrollToTopBtn) {
        scrollToTopBtn.addEventListener("click", function () {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        });
    }

    toggleOnScroll("[data-contact-sun]", {
        offset: 50,
        display: "flex"
    });
});

// Language switcher
document.addEventListener('click', function(e) {
    const switcher = e.target.closest('[data-lang-switcher]');
    const loadingLabels = {
        pl: 'Przygotowujemy wersję językową',
        en: 'Preparing your language version',
        de: 'Sprachversion wird vorbereitet',
        fr: 'Préparation de la version linguistique',
        it: 'Preparazione della versione linguistica',
        cs: 'Připravujeme jazykovou verzi',
        sk: 'Pripravujeme jazykovú verziu',
    };

    const showLanguageLoader = (item) => {
        const flag = item.querySelector('.lang-switcher__flag');
        const languageCode = item.dataset.languageCode || 'en';
        const label = loadingLabels[languageCode] || loadingLabels.en;
        let loader = document.querySelector('[data-language-loader]');

        if (!loader) {
            loader = document.createElement('div');
            loader.className = 'language-loader';
            loader.dataset.languageLoader = '';
            loader.setAttribute('aria-hidden', 'true');
            loader.innerHTML = '<div class="language-loader__content"><span class="language-loader__mark"><span class="language-loader__spinner"></span><span class="language-loader__flag"></span></span><span class="language-loader__label"></span></div>';
            document.body.appendChild(loader);
        }

        const loaderFlag = loader.querySelector('.language-loader__flag');
        const loaderLabel = loader.querySelector('.language-loader__label');
        loaderFlag.innerHTML = flag ? flag.innerHTML : '';
        loaderFlag.classList.toggle('is-wide', flag?.classList.contains('lang-switcher__flag--wide'));
        loaderLabel.textContent = label;
        document.body.classList.add('is-language-loading');
    };

    document.querySelectorAll('[data-lang-switcher].is-open').forEach(el => {
        if (el !== switcher) {
            el.classList.remove('is-open');
            el.querySelector('button')?.setAttribute('aria-expanded', 'false');
        }
    });

    if (!switcher) return;

    const item = e.target.closest('.lang-switcher__item');
    if (item) {
        const url = item.getAttribute('href');
        const isActive = item.classList.contains('is-active');
        const isEmptyUrl = !url || url === '#';

        if (!isActive && !isEmptyUrl) {
            showLanguageLoader(item);
        }

        return;
    }

    const button = e.target.closest('.lang-switcher__current');
    if (!button) return;

    const isOpen = switcher.classList.toggle('is-open');
    button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
});

// Contact sun component
document.querySelectorAll('[data-contact-sun]').forEach((menu) => {
    const trigger = menu.querySelector('.contact-sun__trigger');
    const footer = document.querySelector('#footer');
    const hasHover = window.matchMedia('(hover: hover)').matches;
    let closeTimer = null;

    if (!trigger) return;

    const openMenu = () => {
        clearTimeout(closeTimer);
        menu.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
    };

    const closeMenu = () => {
        menu.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
    };

    const closeMenuDelay = () => {
        closeTimer = setTimeout(() => {
            closeMenu();
        }, 250);
    };

    trigger.setAttribute('aria-expanded', 'false');

    if (footer) {
        const footerObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    closeMenu();
                    menu.classList.add('is-footer-hidden');
                } else {
                    menu.classList.remove('is-footer-hidden');
                }
            });
        }, {
            threshold: 0
        });

        footerObserver.observe(footer);
    }

    if (hasHover) {
        trigger.addEventListener('mouseenter', openMenu);

        menu.addEventListener('mouseenter', () => {
            clearTimeout(closeTimer);
        });

        menu.addEventListener('mouseleave', closeMenuDelay);
    }

    trigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (menu.classList.contains('is-open')) {
            closeMenu();
        } else {
            openMenu();
        }
    });

    document.addEventListener('click', (e) => {
        if (!menu.contains(e.target)) {
            closeMenu();
        }
    });
});

// Offset
document.addEventListener('DOMContentLoaded', function () {
    const getAnchorOffset = () => {
        const header = document.querySelector('#main-header');
        const extraSpace = 30;

        return (header ? header.offsetHeight : 0) + extraSpace;
    };

    const scrollToAnchor = (hash) => {
        if (!hash || hash === '#') {
            return;
        }

        const targetId = hash.replace('#', '');
        const target = document.getElementById(targetId);

        if (!target) {
            return;
        }

        const targetTop = target.getBoundingClientRect().top + window.scrollY;
        const scrollTop = targetTop - getAnchorOffset();

        window.scrollTo({
            top: scrollTop,
            behavior: 'smooth',
        });

        window.history.pushState(null, '', `#${targetId}`);
    };

    document.querySelectorAll('a[href^="#"], .js-anchor-scroll').forEach((link) => {
        link.addEventListener('click', function (event) {
            const hash = link.getAttribute('href');

            if (!hash || hash === '#') {
                return;
            }

            if (!document.getElementById(hash.replace('#', ''))) {
                return;
            }

            event.preventDefault();
            scrollToAnchor(hash);
        });
    });
});
